'use strict';

// 388637
$.spinner = function () {
    return {
        start: function () {},
        stop: function () {}
    };
};

var base = require('base/components/search');
base = typeof base === 'function' ? { baseInit: base } : { ...base };
var minChars = base.minChars;
var endpoint = base.endpoint;

/**
 * Extended Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    var val = $.trim($(scope).val() || '');

    if (val.length >= minChars) {
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent(val),
            method: 'GET',
            success: function (response) {
                base.processResponse.call(this, response);
                if ($('.search-mobile').is(':visible')) {
                    $('.search-mobile .suggestions')
                        .removeClass('modal')
                        .css('top', '');
                }
            },
            error: function () {
            }
        });
    } else {
        $(scope).siblings('.reset-button').removeClass('d-sm-block');
        if (typeof base.clearModals === 'function') {
            base.clearModals();
        }

        if (typeof base.getSuggestionsWrapper === 'function') {
            var $wrapper = base.getSuggestionsWrapper(scope);
            $wrapper.empty().hide();
        }
    }
}

base.initMobileHeaderSearch = function () {
    $('.show-mobile-search').on('click', function (e) {
        e.stopImmediatePropagation();
        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
            $(this).find('.mobile-menu').hide();
        } else {
            $(this).find('.mobile-menu').show();
        }
        $('.search-mobile').toggleClass('d-none');
    });
};

function init() {
    $('.site-search .reset-button').on('click', function () {
        $(this).removeClass('d-sm-block');
        $('input.search-field').focus();
    });
    $('form[name="simpleSearch"]').on('submit', function (e) {
        var searchTerm = $(this).find('.search-field').val().trim();

        if (!searchTerm || !/[a-zA-Z0-9]/.test(searchTerm)) {
            e.preventDefault();

            var $form = $(this); // <-- Add this
            var $wrapper = $form.find('.suggestions-wrapper');
            var suggestionUrl = $wrapper.data('url');

            $.ajax({
                url: suggestionUrl + '?invalidSearch=true',
                success: function (response) {
                    if (!response || $.trim(response).length === 0) {
                        $wrapper.empty().hide();
                        return;
                    }

                    $wrapper.html(response).show();
                }
            });
            return false;
        }
        return true;
    });
}

module.exports = Object.assign({}, base, {
    getSuggestions: getSuggestions,
    init: init
});
